const getPrewImage = (preViewImagePath, size = 'large') => {
  const strplitStrings = preViewImagePath.split('preview-');
  const sizePreviewImage = strplitStrings[0] + `${size}-preview-` + strplitStrings[1];
  return sizePreviewImage;
};

export default getPrewImage;
